import axios from "axios"

// element Ui
import {
	// ElMessage,
	ElNotification,
	ElMessageBox,
	ElLoading 
} from 'element-plus'

// 路由
import router from '@/router'

// vuex 数据
import store from '@/store'

//	工具库
export const util = {
	
	//	配置参数
	config: {
		// apiHost:'https://x.api.qingsuiwang.com',
		// fileHost:'https://x.api.qingsuiwang.com/shop/images/',
		apiHost:'https://zhiduofen.api.aixxzdf.com',
		fileHost:'https://zhiduofen.api.aixxzdf.com/shop/images/',

		prefix:'ying_yu_',

		province:{
			'110000':'北京市',	
			'120000':'天津市',	
			'130000':'河北省',	
			'140000':'山西省',	
			'150000':'内蒙古自治区',	
			'210000':'辽宁省',	
			'220000':'吉林省',	
			'230000':'黑龙江省',	
			'310000':'上海市',	
			'320000':'江苏省',	
			'330000':'浙江省',	
			'340000':'安徽省',	
			'350000':'福建省',	
			'360000':'江西省',	
			'370000':'山东省',	
			'410000':'河南省',	
			'420000':'湖北省',	
			'430000':'湖南省',	
			'440000':'广东省',	
			'450000':'广西壮族自治区',	
			'460000':'海南省',	
			'500000':'重庆市',	
			'520000':'贵州省',	
			'530000':'云南省',	
			'540000':'西藏自治区',	
			'610000':'陕西省',	
			'620000':'甘肃省',	
			'630000':'青海省',	
			'640000':'宁夏回族自治区',	
			'650000':'新疆维吾尔自治区',	
			'710000':'台湾省',	
			'810000':'香港特别行政区',	
			'820000':'澳门特别行政区',	
		}
	},

	parseFloat(val,cou = 2){
		return parseFloat(parseFloat(val).toFixed(cou));
	},

	isRank(keys){
		var rankBut = store.state.rankBut;
		// console.log('typeof rankBut[keys]',typeof rankBut[keys])
        var off = false
        if(keys && keys.length > 0){
            if(typeof rankBut[keys] !== 'undefined'){
                off = true
            }else{
              off = false
            }
        }else{
          off = false
        }

		return off;
	},

	jsonObj(data){
		return JSON.parse(JSON.stringify(data))
	},

	loginIs(fun = '',urlIs = true,load = false){
		var that = this;

		var token = store.state.token;
		if(!token){
			that.getLogin();
		}

		var timesD = that.getTimes();
		var timesJ = store.state.user_times;

		if(token && timesD - timesJ <= 43200 && !load){
			fun ? fun(true) : '' ;
		}else{
			token = that.localGet('token')
			if(token){

				that.requestSync('/login/user/info',(data) => {
					if(data.code == 200){
						util.setLogin(data.data)

						fun ? fun(true) : '' ;
					}else{
						if(urlIs){
							router.push({
								path: '/login'
							})
						}else{
							fun ? fun(false) : '' ;
						}
					}
				});

			}else{
				if(urlIs){
					router.push({
						path: '/login'
					})
				}else{
					fun ? fun(false) : '' ;
				}
			}
		}

	},

	setLogin(user,way = true){
		if(way){
			store.state.user = user
			util.localSet('user',store.state.user)
			store.state.token = user.token
			util.localSet('token',store.state.token)
			store.state.port = user.qsw_user.login_port
			util.localSet('port',store.state.port)
			store.state.rank = user.rank;
			util.localSet('rank',store.state.rank)
			store.state.nav = user.nav;
			util.localSet('nav',store.state.nav)

			store.state.user_times = util.getTimes();
			util.localSet('user_times',store.state.user_times)

		}else{
			store.state.user = 0
			util.localSet('user',store.state.user)
			store.state.token = 0
			util.localSet('token',store.state.token)
			store.state.port = 0
			util.localSet('port',store.state.port)
			store.state.rank = 0
			util.localSet('rank',store.state.rank)
			store.state.nav = 0
			util.localSet('nav',store.state.nav)


			store.state.user_times = 0
			util.localSet('user_times',0)

			
		}
	},

	getLogin(){
		store.state.user = util.localGet('user')
		store.state.token = util.localGet('token')
		store.state.port = util.localGet('port')
		store.state.rank = util.localGet('rank')
		store.state.nav = util.localGet('nav')
		store.state.user_times = util.localGet('user_times')
	},

	url(path){
		router.push({
			path: path
		})
	},

	loginUrl(way = false){
		if(store.state.user != 0 && store.state.token != 0){
			console.log(store.state.port)
			if(store.state.port == 1){
				if(way){
					return '/admin/index/index';
				}else{
					router.push({
						path: '/admin/index/index'
					})
				}
			}else if(store.state.port == 2){
				if(way){
					return '/agency/index/index';
				}else{
					router.push({
						path: '/agency/index/index'
					})
				}
			}else if(store.state.port == 3){
				if(way){
					return '/area/index/index';
				}else{
					router.push({
						path: '/area/index/index'
					})
				}
			}else if(store.state.port == 4){
				if(way){
					return '/sell/index/index';
				}else{
					router.push({
						path: '/sell/index/index'
					})
				}
			}else if(store.state.port == 5){
				if(way){
					return '/serve/index/index';
				}else{
					router.push({
						path: '/serve/index/index'
					})
				}
			}
		}
	},

	logout(){
		util.setLogin({},false);
		router.push({
			path: '/login'
		})
	},

	//	加载效果
	showLoading() {
		ElLoading.service({
			background: "rgba(0,0,0,.3)",
			text: "加载中...",
		})
	},

	//	关闭加载效果
	hideLoading() {
		ElLoading.service({}).close();
	},

	alertTwo(obj){
		ElNotification({
			title: obj.title ? obj.title : '系统提示',
			message: obj.value ? obj.value : '',
			duration: obj.duration || obj.duration === 0 ? obj.duration : 2000,
			position: obj.position ? obj.position : 'bottom-right',
			type: obj.type ? obj.type : 'Warning',
		})
	},

	//	弹窗
	alert(obj,types = 'success') {
		//	这个地方说白了就是 如果只是想提示一句话一个文本的话 就只是弹个小tips
		if (typeof obj == "string" || typeof obj == "number") {
			// ElMessage({
			// 	message: obj,
			// 	type: types, // error
			// 	duration: 2000,
			// 	showClose: false,
			// })

			ElNotification({
				title: '系统提示',
				message: obj,
				duration: 2000,
				position:'bottom-right',
				type: types,
			})

			return
		}

		//	标题
		obj.title = obj.title ? obj.title : ""
		//	提示内容
		obj.value = obj.value ? obj.value : "提示信息"
		//	确定文本
		obj.confirmText = obj.confirmText ? obj.confirmText : "确定"
		//	取消按钮
		obj.cancel = obj.cancel === false ? false : true
		obj.modal = obj.modal === true ? true : false
		//	取消文本
		obj.cancelText = obj.cancelText ? obj.cancelText : "取消"

		obj.type = obj.type ? obj.type : 'warning'
		// 'warning'
		// 'error'
		// 'success'
		
		// 返回Promise对象
		ElMessageBox.alert(obj.value,obj.title,{
			confirmButtonText: obj.confirmText,
			cancelButtonText: obj.cancelText,
			showCancelButton:obj.cancel,

			closeOnClickModal: obj.modal,
			closeOnPressEscape: obj.modal,

			dangerouslyUseHTMLString: true,
			draggable: true,
			center: true,
			showClose: false,
			type: obj.type,
		})
		.then(() => {
			if (typeof obj.success != 'undefined') {
				obj.success();
			}
		})
		.catch(() => {
			if (typeof obj.fail != 'undefined') {
				obj.fail();
			}
		})
	},

	prompt(obj){

		obj.title = obj.title ? obj.title : ""
		//	提示内容
		obj.value = obj.value ? obj.value : "提示信息"
		//	确定文本
		obj.confirmText = obj.confirmText ? obj.confirmText : "确定"
		//	取消文本
		obj.cancelText = obj.cancelText ? obj.cancelText : "取消"

		obj.type = obj.type ? obj.type : 'success'

		ElMessageBox.prompt(obj.value, obj.title, {
			confirmButtonText: obj.confirmText,
			cancelButtonText: obj.cancelText,
		})
		.then(({ value }) => {
			if (typeof obj.success !== 'undefined') {
				obj.success(value);
			}
		})
		.catch(() => {
			if (typeof obj.fail !== 'undefined') {
				obj.fail();
			}
		})
	},

	requestSync(url,func = '') {
		url = util.config.apiHost + (url ? url : '')
		const xhr = new XMLHttpRequest();
		xhr.open('POST', url, false); // 第三个参数为 false 表示同步模式
		xhr.setRequestHeader('Authorization', 'Bearer ' + store.state.token);
		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		xhr.setRequestHeader('Content-Type', 'application/json');
		xhr.setRequestHeader('Accept', 'application/json'); // 告诉服务器返回 JSON 数据
		xhr.send(null);

		var msg = '';
		if (xhr.status === 200) {
			msg = JSON.parse(xhr.responseText);
		} else {
			msg = {code:300,msg:'登录错误'};
		}

		func ? func(msg) : ''
	},

	//	发送网络请求
	request(params) {
		//	返回方法
		return new Promise((resolve, reject) => {
			//	请求地址
			params.url = util.config.apiHost + (params.url ? params.url : '')

			// 判断是否加载
			// var loadId = 0;

			if (typeof params.load === 'undefined') {
				params.load = true;
			}

			if (params.load) {
				if(store.state.requestCou <= 0){
					if(store.state.requestCou < 0){
						store.state.requestCou = 0;
					}
					store.state.requestCou += 1;
					
					util.showLoading()
					// loadId = setTimeout(function(){
					// 	util.showLoading()
					// },100)
				}
			}

			//	请求方式
			params.method = params.method ? params.method : "POST"

			if(!params.data){
				params.data = {};
			}

			//	定义头部
			params.headers = {
				'Authorization': 'Bearer '+store.state.token,  // 看到这个token了没有，它在在第一步的第三行出现过~

				...params.headers,
			}

			params.data = params.data ? params.data : {};
			params.data.is_p = 'web';
			//	发送数据
			if (params.method == "POST") {
				if (!params.headers) {
					params.data = params.data ? JSON.stringify(params.data) : ""
				}
			} else {
				//	设置get传参
				params.params = params.data
				//	移除post类型下的data 改用params
				delete(params.data);
			}

			//	定义数据

			//	数据类型
			params.dataType = "json"

			// 发起网络请求
			axios(params)
			.then(res => {

				// if(loadId){
				// 	clearInterval(loadId)
				// }

				//
				if (params.load) {
					store.state.requestCou -= 1;
					if(store.state.requestCou <= 0){
						store.state.requestCou  = 0;
						util.hideLoading()
					}
				}

				// 如果
				if (
					res.data.code >= 400 && res.data.code <= 500
					|| res.code == 0
				) {

					if(res.data.code == 444){

						util.alert({
							type:'error',
							cancel:false,
							value:'您的登录状态已丢失，请重新登录',
							success:() => {
								util.logout();
							}
						});

					}else{
						if(res.code == 0){
							// 登出
							util.alert({
								type:'error',
								cancel:false,
								value:'系统错误',
							});
						}else{
							// 登出
							util.alert({
								type:'error',
								cancel:false,
								value:'暂无权限',
							});
							return
						}
					}
					
				}

				//	帮助突破技术瓶颈，提升思维能力
				params.success ? params.success(res.data) : () => {}

				resolve(res.data)
			})
			.catch(err => {
				//
				if (params.load) {
					util.hideLoading()
				}

				params.fail ? params.fail(err) : () => {}

				if(err.code == "ERR_BAD_RESPONSE"){
					// 登出
					util.alert({
						type:'error',
						cancel:false,
						value:'系统错误',
					});
					return
				}


				// 失败
				reject(err)
			})
		})
	},

	// 对二补齐
	toTwo(str) {
		// 格式化字符
		let num = String(Number(str));

		// 判断时间
		if (num.length < 2) {
			num = '0' + num;
		}

		// 返回时间
		return num;
	},

	// 获取时间戳
	getTimes() {
		// 当前时间
		const date = new Date()
		// 当前时间
		const now = parseInt(date.valueOf() / 1000)
		// 返回时间
		return now

	},

	getHis(his,way = 3){

		var h = Math.floor(his / 3600);
		h = h < 10 ? '0'+h : h;

		if(way == 1){
			return h;
		}

		var ss = his % 3600;
		var i = Math.floor(ss / 60);
		i = i < 10 ? '0'+i : i;

		if(way == 2){
			return h+':'+i;
		}

		var s = ss % 60;
		s = s < 10 ? '0'+s : s;

		return h+':'+i+':'+s;
	},

	/**
	 * 时间戳处理成时间
	 * @param {String} str 规则如下
	 * 时间格式		月、日、时、分、秒 单个字母不补0
	 * yyyy	年
	 * MM	月
	 * dd	日
	 * WW	周
	 * HH	小时	24小时制
	 * hh	小时	12小时制
	 * mm	分钟
	 * ss	秒
	 * a	am/pm
	 * 比如 'yyyy-MM-dd HH:mm:ss 周w a' 返回2023-02-06 11:19:19 周一 pm
	 * @param {Number} timestamp 需要处理的时间戳
	 * @return {String} 日期字符串
	 */
	getDate(str, timestamp) {
		// 当前时间
		const nowDate = new Date()
		// 周列表	歪果仁把周日放在第一位
		let weekList = ['日', '一', '二', '三', '四', '五', '六']

		// 格式化字符串
		if (!str || typeof str != 'string') {
			str = 'yyyy-MM-dd HH:mm:ss'
		}

		// 格式化时间戳
		if (!timestamp) {
			if(timestamp === 0){
				return ''
			}else{
				timestamp = nowDate.valueOf()
			}
		} else if (String(timestamp).length <= 10) {
			timestamp = timestamp * 1000
		}

		// 时间
		const date = new Date(timestamp)

		// 获取对应时间
		let year = date.getFullYear(),
			moth = date.getMonth() + 1,
			day = date.getDate(),
			week = date.getDay(),
			hour = date.getHours(),
			minute = date.getMinutes(),
			second = date.getSeconds()

		// 处理年
		str = str.replace('yyyy', year)
		// 处理月份
		str = str.replace('MM', this.toTwo(moth))
		str = str.replace('M', moth)
		// 处理日
		str = str.replace('dd', this.toTwo(day))
		str = str.replace('d', day)
		// 处理周
		str = str.replace('w', weekList[week])
		// 处理小时
		if (str.match('h')) {
			// 12小时制
			hour = hour > 12 ? hour - 12 : hour
			// 12小时制
			str = str.replace('hh', this.toTwo(hour))
			str = str.replace('h', hour)
		} else if (str.match('H')) {
			// 24小时制
			str = str.replace('HH', this.toTwo(hour))
			str = str.replace('H', hour)
		}
		// 处理分钟
		str = str.replace('mm', this.toTwo(minute))
		str = str.replace('m', minute)
		// 处理秒
		str = str.replace('ss', this.toTwo(second))
		str = str.replace('s', second)
		// 处理是上午还是下午
		let a = hour > 12 ? 'am' : 'pm'
		str = str.replace('a', a)
		return str
	},

	localGet(str = ''){
		var dataJson = localStorage.getItem(this.config.prefix + str);
        if(dataJson && dataJson != 'undefined' && dataJson != 'null'){
            return JSON.parse(dataJson);
        }else{
            return false;
		}
	},

	localSet(str = '',data = ''){
		localStorage.setItem(this.config.prefix + str,JSON.stringify(data));
	},

	load_times_if(str){

		if(store.state.load_times){
			var load_times = store.state.load_times[str];
			if(load_times != 'undefined' && load_times){
				// 判断服务器中的版本号
				console.log(str+'_load_times',load_times)

				// 缓存数据中的版本号
				var log_times = util.localGet(str);
				if(!log_times || load_times != log_times){
					util.localSet(str,load_times);
					return false;
				}else{
					return true;
				}

			}else{
				// 没有版本号
				return false;
			}
		}else{
			// 没有版本号
			return false;
		}

	},

	setCopyText(text) {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		
		// 添加到文档中
		textarea.style.position = 'fixed';
		textarea.style.left = '0';
		textarea.style.top = '0';
		document.body.appendChild(textarea);
		
		// 选择文本
		textarea.select();
		
		try {
			const result = document.execCommand('copy');
			if (result) {
				util.alert('复制成功!');
			} else {
				util.alert('复制失败!','error');
			}
		} catch (error) {
				util.alert('复制错误!','error');
		}
		
		// 移除元素
		textarea.remove();
	},

	down(){
		
	},

	setOn(that,func = ''){
		that.pageKey = 'load_'+that.$route.path;
		// console.log('-------登录界面监听-------'+that.pageKey)
		store.state.load_path_no[that.pageKey] = 1;
		that.$eventBus.on(that.pageKey, (data) => {
			// console.log('-------调用-登录界面-------'+that.pageKey)
			func ? func(data) : '';
		});

	},
	
	setUrlOn(url,that,func = ''){
		that.pageKey = url;
		// console.log('-------登录界面监听-------'+that.pageKey)
		store.state.load_path_no[that.pageKey] = 1;
		that.$eventBus.on(that.pageKey, (data) => {
			// console.log('-------调用-登录界面-------'+that.pageKey)
			func ? func(data) : '';
		});

	},

	delOn(that){
		delete store.state.load_path_no[that.pageKey];
		that.$eventBus.off(that.pageKey);
	},

}

export default util
